import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SignIn.css";
import { Link } from "react-router-dom";
import AuthService from "service/AuthService";

const SignInPage: React.FC = () => {
  const [isLoadingLogin, setIsLoadingLogin] = React.useState<boolean>(false);
  const [emailOrPhone, setEmailOrPhone] = React.useState<string>("");
  const [error, setError] = React.useState<string>("");

  const [successSendUrl, setSuccessSendUrl] = React.useState<boolean>(false);

  const authService = AuthService();

  const handleSignIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setIsLoadingLogin(true);
      setError("");
      const res = await authService.sendDashboardUrl(emailOrPhone);
      console.log('Dashboard URL Sent', res);
      setSuccessSendUrl(true);
    } catch (error) {
      console.error('Login Error:', error);
      setError(error as string);
    } finally {
      setIsLoadingLogin(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="header-gradient text-center d-flex flex-column align-items-center justify-content-center">
        <img src="/assets/logo/master-perfect-store-202512.png" alt="Perfect Store" className="logo" />
      </div>

      <div className="px-4" style={{ marginTop: "-100px" }}>
        <div className="form-section px-4 mx-0 w-100">
          <h3 className="fw-bold mb-4">Masuk</h3>
          {
            !successSendUrl && (
              <>
                <form onSubmit={handleSignIn} className="mb-3">
                  <label className="form-label fw-semibold text-ps-primary">
                    Email atau Nomor Whatsapp
                  </label>
                  <input
                    type="text"
                    className="form-control input-rounded"
                    placeholder="Email atau Nomor Whatsapp"
                    value={emailOrPhone}
                    onChange={(e) => setEmailOrPhone(e.target.value)}
                  />
                  <button disabled={isLoadingLogin} type="submit" className="btn btn-gradient w-100 mt-3" style={{ color: 'white' }}> {isLoadingLogin ? <div className="spinner-border text-outline-primary" /> : "Masuk"}</button>
                </form>
                {error && <p className="text-danger">{error}</p>}
              </>
            )
          }
        </div>

        {successSendUrl && (
          <div className="form-section px-4 mx-0 w-100">
            <div className="mb-3 text-center">
              <p>
                Kami telah mengirimkan URL dashboard ke {emailOrPhone.includes("@") ? "email" : "nomor WhatsApp"} <b>{emailOrPhone}</b> milik Anda.
                Silakan klik tautan yang telah kami kirimkan untuk mengakses dashboard.
                <br />
                Harap jangan membagikan tautan tersebut kepada siapa pun demi keamanan akun Anda.
                <br />
                <Link to="https://www.perfectstore.id">Pelajari lebih lanjut</Link>
              </p>
            </div>
          </div>
        )}
        <div className="mt-5 text-center">
          <p>Tersedia juga aplikasi Perfect Store di</p>
          <Link to="https://play.google.com/store/apps/details?id=com.transmora.perfectstore" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/google-playstore.webp" alt="Perfect Store - by TransMore" style={{ width: 172 }} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;